@for (item of data; track item; let i = $index) {
  <div class={{item.class}}>
    <div class="name">{{item.title}}</div>
    <div class="radios">
      <mat-radio-group>
        @for (type of item.radios; track type) {
          <mat-radio-button color="primary" checked={{type.checked}} [value]="type.name"
          (change)="radioChange($event, item)">{{type.name}}</mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <div class="value">
      @for (subItem of item.values; track subItem) {
        <input matInput type="number" disabled={{subItem.disabled}}
          [value]="subItem.value" (blur)="onUpdate($event, item)" />
      }
    </div>
  </div>
}